import { render, staticRenderFns } from "./Precalculo.vue?vue&type=template&id=23d66c6c&lang=true"
import script from "./Precalculo.vue?vue&type=script&lang=js"
export * from "./Precalculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports